import React from "react"
import Chart from "react-apexcharts"

const LineChart = ({ type, data }) => {
  const options = {
    chart: {
      type: "line",
      toolbar: {
        show: false, // This will hide the toolbar buttons
      },
    },
    xaxis: {
      categories: data.map((parse, index) => {
        return index + 1
      }),
      tickAmount: 10,
    },
    yaxis: {
      labels: {
        show: true,
      },
    },
    stroke: {
      curve: "smooth",
    },
  }

  const series = [
    {
      name: "Users",
      data: data.map(user => user.count),
    },
  ]

  return (
    <div style={{ width: "100%", flexGrow: 1 }} className="bg-white w-full ">
      <Chart
        options={options}
        series={series}
        type="line"
        height={300}
        width="100%"
      />
    </div>
  )
}

export default LineChart
